// src/components/LazyMount.jsx
import { useEffect, useRef, useState } from "react";

export default function LazyMount({ rootMargin = "200px", children }) {
  const ref = useRef(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!ref.current || mounted) return;
    const io = new IntersectionObserver(
      entries => {
        if (entries.some(e => e.isIntersecting)) {
          setMounted(true);
          io.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 }
    );
    io.observe(ref.current);
    return () => io.disconnect();
  }, [mounted]);

  return <div ref={ref}>{mounted ? children : null}</div>;
}
